<template>
	<div class="relative">
		<input type="range" :min="min" :max="max" :step="step" v-model="leftEyeScoreIndex">
	</div>
</template>

<script>
export default {
	props: {
		max: Number,
		min: { type: Number, default: 0 },
		step: { type: [Boolean, Number], default: false }
	}
}
</script>